// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","title":"Header_title__3SEjb","typing":"Header_typing__332DT","blink-caret":"Header_blink-caret__1T-wx"};